import {createElement, Component, PropTypes} from 'rlink-react';

import {COUNTRY_LABELS} from 'rlink-regions/messages';
import inspectableError from 'rlink-inspectable-error';


export default function getLabelFromCountryCode (countryCode) {
  countryCode = countryCode.toUpperCase()
  if (countryCode in COUNTRY_LABELS) {
    return COUNTRY_LABELS[countryCode.toUpperCase()];
  }

  throw inspectableError`Invalid country code '${countryCode}' in getLabelFromCountryCode.`;
}



// WEBPACK FOOTER //
// ./lib/rlink-regions/getLabelFromCountryCode.jsx